import { ChevronLeftIcon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { Breadcrumb } from '@/components/Breadcrumbs';
import { useRun } from '@/hooks/useSwr';
import { appPublicPath, appRunPath } from '@/utils/constants';

export function PublicRunPlaygroundCrumb() {
  const { shareToken, runId } = useParams();
  const publicRun = useRun({
    id: runId,
    shareToken: { runShareToken: shareToken },
  });

  const run = publicRun.data;
  if (run == null) return null;

  const pathBack = runId
    ? `/${appPublicPath}/${shareToken}/${appRunPath}/${runId}`
    : `/${appPublicPath}/${shareToken}/${appRunPath}`;

  return (
    <Breadcrumb
      path={pathBack}
      name={`Back to ${run.name} Run`}
      icon={
        <ChevronLeftIcon
          className="size-4"
          sx={{
            marginLeft: 0,
            w: 4,
            h: 4,
            color: 'neutral.400',
          }}
        />
      }
      isFirst
    />
  );
}
